/* eslint-disable react/react-in-jsx-scope */
import { Input, Table } from "antd";
import { DV3SearchIcon } from "../../../../common/icons";
import HUBContext from "../../../../services/HUBContext";
import { VehicleTableCardBase } from "../../../Dash/components/v3/vehicleTableCard";
import React, { Suspense } from "react";
import { injectIntl } from "react-intl";
import { Link } from "react-router-dom";
import CustomColumns from "../../../../helpers/customColumns";
import { withAlert } from "react-alert";
import { withStyles } from "@material-ui/core";
import { setHardFilter } from "../../../../common/utils";
import LoaderSpinner from "../../../../helpers/LoaderSpinner";
import { ROUTER_MAP_PATH } from "../../../../EmbeddedRoutes";
import Error from "../../../../helpers/Error";
import CustomPaginatorWidget from "../CustomPaginatorWidget/CustomPaginatorWidget";
import { translations } from "./constants";
import { styles } from "./VehicleTableCardWidget.styles"
import { getVehicles } from "../../../../services/api/hubcatalog/one-mobility-single-registry-service";

class VehicleTableCardWidget extends VehicleTableCardBase {
  prepareColumnSet() {
    const { intl } = this.props;

    this.columnsSet = [
      {
        dataIndex: "plate",
        title: intl.formatMessage(translations.columns.plate),
        sorter: true,
        width: 170,
      },
      {
        dataIndex: "name",
        title: intl.formatMessage(translations.columns.name),
        sorter: true,
        width: 170,
      },
      {
        dataIndex: "vehicleStatus.name",
        title: intl.formatMessage(translations.columns.status),
        sorter: true,
        width: 170,
        render: (text, record, _) => this.getVehicleStatus(text, record),
      },
      {
        dataIndex: "ownershipStatus.name",
        title: intl.formatMessage(translations.columns.ownershipStatus),
        sorter: true,
        width: 170,
        render: (text, record, _) => this.getOwnershipStatus(text, record),
      },
      {
        dataIndex: "vehicleBrand.name",
        title: intl.formatMessage(translations.columns.vehicleBrand),
        sorter: true,
        width: 170,
      },
      {
        dataIndex: "vehicleModel.name",
        title: intl.formatMessage(translations.columns.vehicleModel),
        sorter: true,
        width: 170,
      },
    ];
  }

  refreshData() {
    const { response } = this.state;
    const { pageSize, sortProperty, sortDirection } = response || {};

    this.getData(pageSize || 5, 0, sortProperty, sortDirection, "");
  }

  getData = (take, skip, sortProperty, sortDirection, search) => {
    const { response, stateuid } = this.state;
    const { locale, company } = this.context;
    const companyID = company?.companyID || 0;

    let pageSize = take || response?.pageSize || 5;
    let pageIndex = !response?.data ? 0 : parseInt(skip / pageSize);

    const request = {
      pageIndex,
      pageSize,
      search: search ? search : response?.search ? response.search : "",
      sortProperty: sortProperty || "",
      sortDirection: sortDirection || "asc",
      cacheControl: stateuid,
      filters: {
        companyID: companyID,
        ...this.getPrefilters(),
      },
    };

    getVehicles(companyID, locale, request)
      .then((response) => {
        this.mapResponseData(response);

        this.setState({
          ready: true,
          loading: false,
          error: false,
          response: response.data,
        });
      })
      .catch((error) => {
        this.setState({ ready: true, error: true, loading: false });
      });
  };

  render() {
    const { widget, intl, classes } = this.props;
    const {
      loading,
      error,
      ready,
      response,
      search,
      visibleColumns,
      showCustomizeColumns,
      singleRegistryIsActive,
    } = this.state;
    const { company } = this.context;

    const columns = [...visibleColumns, "vehicleModel.name", "_whitespace"].map((c) =>
      this.columnsSet.find((x) => x.dataIndex === c),
    );

    if (loading || !ready || !this.columnsSet) {
      return (
        <div className={classes.centerContainer}>
          <LoaderSpinner info={intl.formatMessage(translations.loadData)} />
        </div>
      );
    }

    if (error) {
      return (
        <div className={classes.centerContainer}>
          <Error
            title={intl.formatMessage(translations.error.title)}
            subtitle={intl.formatMessage(translations.error.subtitle)}
            actionLabel={intl.formatMessage(translations.error.actionLabel)}
            action={() => this.refreshData()}
          />
        </div>
      );
    }

    return (
      <Suspense fallback={<div></div>}>
        <div className={classes.contentHeader}>
          <h3 className={classes.headerTitle}>
            {intl.formatMessage(translations.title)}
          </h3>
          <div className={classes.contentLinks}>
            {singleRegistryIsActive && (
              <Link
                className="v3-button"
                to={ROUTER_MAP_PATH.vehicles.syncHistoryPage?.replace(
                  ":cid",
                  company?.companyID,
                )}
              >
                <span>{intl.formatMessage(translations.syncHitory)}</span>
              </Link>
            )}

            <Link
              className="v3-button"
              to={`${ROUTER_MAP_PATH.vehicles.uploadPage}?skip_solutions=${!singleRegistryIsActive}`?.replace(
                ":cid",
                company?.companyID,
              )}
            >
              <span>{intl.formatMessage(translations.batchUpload)}</span>
            </Link>
          </div>
        </div>

        <div className={`${widget.componentKey}`}>
          <div className="separator-row" style={{ marginTop: "16px" }}></div>

          <div className="filters-area">
            <div className={`filters-area-search ${classes.filterAreaSearch}`}>
              <Input
                value={search}
                onChange={({ target: { value } }) =>
                  this.setState({ search: value })
                }
                onPressEnter={this.onSearchEnter}
                placeholder={intl.formatMessage(translations.search)}
                addonAfter={
                  <DV3SearchIcon
                    onClick={() =>
                      this.onSearchEnter({ target: { value: search } })
                    }
                  />
                }
              />
            </div>
          </div>

          <div className="table-area">
            <Table
              pagination={false}
              scroll={{ x: 500 }}
              dataSource={response?.data || []}
              columns={[...columns.filter((x) => !!x)]}
              onChange={this.onTableChange}
              rowKey={"vehicleID"}
            />

            <CustomPaginatorWidget
              pagerInfo={response}
              onChange={(current) =>
                this.getData(
                  response?.pageSize || 5,
                  (current > 0 ? current - 1 : 0) * (response?.pageSize || 5),
                  response?.sortProperty,
                  response?.sortDirection || "asc",
                )
              }
              onShowSizeChange={(current, size) =>
                this.getData(
                  size,
                  (current > 0 ? current - 1 : 0) * size,
                  response?.sortProperty,
                  response?.sortDirection || "asc",
                )
              }
            />
          </div>
        </div>

        <CustomColumns
          visible={showCustomizeColumns}
          columnsSet={this.columnsSet}
          visibleColumns={visibleColumns}
          onCancel={() => this.setState({ showCustomizeColumns: false })}
          onOk={(v) => {
            if (v.length <= 0) return;
            this.setState(
              { visibleColumns: v, showCustomizeColumns: false },
              () => {
                setHardFilter("vehicles-v2-table-columns", v);
              },
            );
          }}
        />
      </Suspense>
    );
  }
}

VehicleTableCardWidget.contextType = HUBContext;
export default withAlert()(
  withStyles(styles)(injectIntl(VehicleTableCardWidget)),
);
